import logger from '~/shared/utils/logger';

export const Position = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  RIGHT: 'RIGHT',
  LEFT: 'LEFT',
  CENTER: 'CENTER',
};

/**
 * Parses a position string similar to CSS `background-position`'s keyword values
 *
 * For example,
 * `center`      -> `[CENTER, CENTER]`
 * `left`        -> `[CENTER, LEFT]`
 * `top`         -> `[TOP, CENTER]`
 * `bottom left` -> `[BOTTOM, LEFT]`
 */
const parsePositionString = (positionString) => {
  if (!positionString) {
    return;
  }

  const parts = positionString.trim().toUpperCase().split(' ');
  const possiblePositions = Object.values(Position);
  const isValid =
    parts.length < 3 && parts.every((part) => possiblePositions.includes(part));

  if (!isValid) {
    if (process.env.NODE_ENV === 'development') {
      logger(`Invalid position string "${positionString}"`);
    }

    return;
  }

  const isVertical = (p) => p === Position.TOP || p === Position.BOTTOM;
  const isHorizontal = (p) => p === Position.LEFT || p === Position.RIGHT;

  let verticalPosition = Position.CENTER;
  let horizontalPosition = Position.CENTER;

  if (parts.length === 1) {
    if (isVertical(parts[0])) {
      verticalPosition = parts[0];
    } else if (isHorizontal(parts[0])) {
      horizontalPosition = parts[0];
    } else {
      verticalPosition = parts[0];
      horizontalPosition = parts[0];
    }
  }

  if (parts.length === 2) {
    if (isVertical(parts[0]) && !isVertical(parts[1])) {
      verticalPosition = parts[0];
      horizontalPosition = parts[1];
    } else if (!isVertical(parts[0]) && isVertical(parts[1])) {
      verticalPosition = parts[1];
      horizontalPosition = parts[0];
    } else if (isHorizontal(parts[0]) && !isHorizontal(parts[1])) {
      horizontalPosition = parts[0];
      verticalPosition = parts[1];
    } else if (!isHorizontal(parts[0]) && isHorizontal(parts[1])) {
      horizontalPosition = parts[1];
      verticalPosition = parts[0];
    }
  }

  return [verticalPosition, horizontalPosition];
};

export default parsePositionString;
